import {apiInstance} from "../api";

// «Эффективность по лидам»: each employee's leads of a funnel
export class LeadStatsService {
  // {from, to: 'YYYY-MM-DD', funnel}
  static fetchReport(params) {
    return apiInstance.get('/lead-stats', {params});
  }
}
